// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/PalaceScriptMT.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/menu_background_rotated_min.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Palace Script MT';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

html, body {
  height: 100%;
  margin: 0;
}

body {
  position: relative;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

body::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center center;
  background-size: cover;
  z-index: -1;
}

.home-container {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  padding-top: 5%;
  text-align: center;
}

.intro-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 70vh;
}

.continue-button {
  margin-top: 20px;
  padding: 10px 20px;
  font-size: 1.5rem;
  font-family: 'Times New Roman', serif;
  background-color: #333;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  opacity: 0;
  transition: opacity 7s ease-in-out;
}

.continue-button.fade-in {
  opacity: 1;
}

.continue-button:hover {
  background-color: #555;
}

#home {
  display: none;
}

#home.show {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0;
  position: relative;
  overflow: hidden;
  padding-bottom: 340px;
}

.phone-link-2 {
  color: inherit; /* Inherit color from parent */
  text-decoration: none; /* Remove underline */
}

.phone-link-2:hover,
.phone-link-2:focus,
.phone-link-2:active {
  color: inherit; /* Inherit color on hover/focus/active */
  text-decoration: none; /* Remove underline on hover/focus/active */
}


#b-circledLeaves27 {
  color: black;
  text-decoration: underline;
}

.home-top-info {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 100px;
  padding: 0 5%;
  position: relative;
  z-index: 10;
}

.work-time.lifted {
  text-align: center;
  width: 100%;
  margin: 0 auto;
  padding: 0;
}

.circle-badge {
  margin-top: 0;
  position: absolute;
  /* top: 50px; */
  right: 10%;
  z-index: 2;
}

@media (max-width: 768px) {
  .home-container{
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center center;
    background-size: cover;
  }

  #home p {
    font-family: Georgia, serif;
    color: #333;
    font-size: 1rem !important;
    font-weight: normal;
    margin: 0;
    text-align: justify;
    line-height: 1.5;
  }
  
  .first-letter {
    font-family: 'Palace Script MT', cursive;
    font-size: 2.5rem !important;
    line-height: 0.8;
  }

  footer {
    margin-top:0% !important;
  }
  
  #home.show {
    flex-direction: column;
    align-items: center;
    
  }

  .left-side {
    width: 85% !important;
    padding-left: 0;
    margin-right: 0;
    padding-top: 20px !important;
    padding-left: 0% !important;

  }

  .right-side {
    width: 80% !important;
    margin-right: 0;
    padding-top: 20% !important;
    padding-left: 7% !important;
    padding-bottom: 20% !important;
    z-index: 101;
  }

  .giant-image {
    /* padding-top: 40% !important; */
    right: 0% !important;
    top: 30% !important;
    max-width: 100% !important;
    opacity: 0.8 !important;
  }

  .cards {
    margin-top: 20px;
  }


  .menu-link-text {
    font-size: 3rem !important;
    /* marign-top: 20% !important; */
    font-weight: 600 !important;
  }

  .work-time {
    padding-top: 20% !important;
    font-weight: bold !important;
    z-index: 1002;
    /* padding-bottom: 20% !important; */
  }

  .home-top-info {
    flex-direction: column;
    align-items: center;
    padding: 50px 5% 0 5%;
  }

  .circle-badge {
    position: static;
    margin-bottom: 20px;
  }

  .work-time.lifted {
    width: auto;
    margin: 0;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .home-container{
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center center;
    background-size: cover;
    padding-top: 20%;
  }
  
  footer {
    margin-top:0% !important;
  }

  .right-side {
    width: 50% !important;
    margin-right: 0;
    padding-top: 20% !important;
    padding-left: 7% !important;
    padding-bottom: 20% !important;
    z-index: 101;
  }
  
}

@media (min-width: 3840px) {
 
  #home p {
    font-family: Georgia, serif;
    color: #333;
    font-size: 4rem !important;
    font-weight: normal;
    margin: 0;
    text-align: justify;
    line-height: 1.5;
  }
  
  .first-letter {
    font-family: 'Palace Script MT', cursive;
    font-size: 12rem !important;
    line-height: 0.8;
  }

  .menu-link-text {
    font-size: 10rem !important;
  }
  
  .menu-link-container {
    bottom: 0% !important;
  }

  .giant-image {
    position: absolute;
    right: 62% !important;
    top: 20%;
    max-width: 40%;
    height: auto;
    opacity: 0;
    transition: opacity 2s ease-in-out;
    z-index: 1;
  }
}

.left-side {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  width: 55%;
  padding-left: 5%;
  padding-top: 5%;
}

.giant-image {
  position: absolute;
  right: 60%;
  top: 20%;
  max-width: 40%;
  height: auto;
  opacity: 0;
  transition: opacity 2s ease-in-out;
  z-index: 1;
}

.giant-image.fade-in {
  opacity: 0.5;
}

.work-time {
  padding-top: 5%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  transition: opacity 4s ease-in-out;
}

#home {
  padding-top: 0 !important;
}

.work-time.fade-in {
  opacity: 1;
}

.text-container {
  left: 5%;
  align-items: justify;
  z-index: 2;
}

#home p {
  font-family: Georgia, serif;
  color: #333;
  font-size: 30px;
  font-weight: normal;
  margin: 0;
  text-align: justify;
  line-height: 1.5;
}

.first-letter {
  font-family: 'Palace Script MT', cursive;
  font-size: 6rem;
  line-height: 0.8;
}

.first-letter-two {
  font-family: 'Palace Script MT', cursive;
  font-size: 8rem;
  line-height: 0.8;
}

.first-letter-three {
  font-family: 'Palace Script MT', cursive;
  font-size: 4rem;
  line-height: 0.8;
}

.work-text {
  font-family: 'Palace Script MT', cursive;
  font-size: 6rem;
  line-height: 0.8;
}

.chunk {
  display: inline-block;
  transition: transform 0.3s ease-in-out;
  cursor: pointer;
}

.animated-text {
  opacity: 0;
  transition: opacity 4s ease-in-out;
}

.animated-text.fade-in {
  opacity: 1;
}

.chunk:hover {
  transform: scale(1.1);
}

.right-side {
  width: 30%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 8%;
  padding-top: 3%;
  opacity: 0;
  transition: opacity 4s ease-in-out;
}

.right-side.fade-in {
  opacity: 1;
}

.cards {
  position: relative;
  list-style-type: none;
  padding: 0;
  width: 100%;
  margin: 0;
}

.card {
  position: relative;
  background: #ccc;
  border-radius: 30px;
  box-shadow: 0 0 40px #000;
  transform: translateY(0) rotate(0) translateX(0) scale(1);
  transform-origin: 0 0;
  transition: transform 0.6s cubic-bezier(.8,.2,.1,0.8) 0.1s, background 0.4s linear;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  width: 100%;
  z-index: 1;
}

.card img {
  width: 100%;
  height: auto;
  border-radius: 30px;
  transition: transform 0.3s ease-in-out;
}

.card--current {
  cursor: pointer;
  -webkit-user-select: auto;
          user-select: auto;
  position: relative;
  z-index: 5;
  opacity: 1;
  margin-top: -40%;
  background: #EEE;
}

.card--next {
  z-index: 3;
}

.card--out {
  z-index: 4;
  margin-top: -40%;
}

.card img:hover {
  transform: scale(1.1);
}

.radno-vrijeme-kuhinje {
  display: flex;
  margin-top: 10%;
  align-items: center;
  justify-content: center;
  font-family: 'Palace Script MT', cursive;
  font-size: 2rem;
}

#home.show {
  display: flex;
}

.menu-link-container {
  position: absolute;
  bottom: 20%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  opacity: 0;
  transition: opacity 4s ease-in-out;
}

.menu-link-container.fade-in {
  opacity: 1;
}

.menu-link-text {
  font-family: 'Palace Script MT', cursive;
  font-size: 5rem;
  color: #333;
  text-decoration: none;
}

.menu-link-text:hover {
  color: #555;
}

footer {
  margin-top:20%;
}
`, "",{"version":3,"sources":["webpack://./src/components/home/Home.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,+DAAoE;AACtE;;AAEA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2EAAuF;EACvF,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;EACrC,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc,EAAE,8BAA8B;EAC9C,qBAAqB,EAAE,qBAAqB;AAC9C;;AAEA;;;EAGE,cAAc,EAAE,wCAAwC;EACxD,qBAAqB,EAAE,2CAA2C;AACpE;;;AAGA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,UAAU;AACZ;;AAEA;EACE;IACE,2EAAuF;IACvF,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;IAC3B,WAAW;IACX,0BAA0B;IAC1B,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,wCAAwC;IACxC,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;;EAErB;;EAEA;IACE,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,4BAA4B;IAC5B,2BAA2B;;EAE7B;;EAEA;IACE,qBAAqB;IACrB,eAAe;IACf,2BAA2B;IAC3B,2BAA2B;IAC3B,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,iCAAiC;IACjC,oBAAoB;IACpB,mBAAmB;IACnB,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;;EAGA;IACE,0BAA0B;IAC1B,gCAAgC;IAChC,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;IAC5B,aAAa;IACb,oCAAoC;EACtC;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,SAAS;EACX;AACF;;AAEA;EACE;IACE,2EAAuF;IACvF,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,qBAAqB;IACrB,eAAe;IACf,2BAA2B;IAC3B,2BAA2B;IAC3B,8BAA8B;IAC9B,YAAY;EACd;;AAEF;;AAEA;;EAEE;IACE,2BAA2B;IAC3B,WAAW;IACX,0BAA0B;IAC1B,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,wCAAwC;IACxC,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,QAAQ;IACR,cAAc;IACd,YAAY;IACZ,UAAU;IACV,kCAAkC;IAClC,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,UAAU;EACV,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,QAAQ;EACR,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,yDAAyD;EACzD,qBAAqB;EACrB,kFAAkF;EAClF,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB","sourcesContent":["@font-face {\n  font-family: 'Palace Script MT';\n  src: url('../../assets/fonts/PalaceScriptMT.ttf') format('truetype');\n}\n\nhtml, body {\n  height: 100%;\n  margin: 0;\n}\n\nbody {\n  position: relative;\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\nbody::before {\n  content: '';\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: url('../../assets/menu_background_rotated_min.jpg') no-repeat center center;\n  background-size: cover;\n  z-index: -1;\n}\n\n.home-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding-top: 5%;\n  text-align: center;\n}\n\n.intro-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 70vh;\n}\n\n.continue-button {\n  margin-top: 20px;\n  padding: 10px 20px;\n  font-size: 1.5rem;\n  font-family: 'Times New Roman', serif;\n  background-color: #333;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity 7s ease-in-out;\n}\n\n.continue-button.fade-in {\n  opacity: 1;\n}\n\n.continue-button:hover {\n  background-color: #555;\n}\n\n#home {\n  display: none;\n}\n\n#home.show {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 0;\n  position: relative;\n  overflow: hidden;\n  padding-bottom: 340px;\n}\n\n.phone-link-2 {\n  color: inherit; /* Inherit color from parent */\n  text-decoration: none; /* Remove underline */\n}\n\n.phone-link-2:hover,\n.phone-link-2:focus,\n.phone-link-2:active {\n  color: inherit; /* Inherit color on hover/focus/active */\n  text-decoration: none; /* Remove underline on hover/focus/active */\n}\n\n\n#b-circledLeaves27 {\n  color: black;\n  text-decoration: underline;\n}\n\n.home-top-info {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-top: 100px;\n  padding: 0 5%;\n  position: relative;\n  z-index: 10;\n}\n\n.work-time.lifted {\n  text-align: center;\n  width: 100%;\n  margin: 0 auto;\n  padding: 0;\n}\n\n.circle-badge {\n  margin-top: 0;\n  position: absolute;\n  /* top: 50px; */\n  right: 10%;\n  z-index: 2;\n}\n\n@media (max-width: 768px) {\n  .home-container{\n    background: url('../../assets/menu_background_rotated_min.jpg') no-repeat center center;\n    background-size: cover;\n  }\n\n  #home p {\n    font-family: Georgia, serif;\n    color: #333;\n    font-size: 1rem !important;\n    font-weight: normal;\n    margin: 0;\n    text-align: justify;\n    line-height: 1.5;\n  }\n  \n  .first-letter {\n    font-family: 'Palace Script MT', cursive;\n    font-size: 2.5rem !important;\n    line-height: 0.8;\n  }\n\n  footer {\n    margin-top:0% !important;\n  }\n  \n  #home.show {\n    flex-direction: column;\n    align-items: center;\n    \n  }\n\n  .left-side {\n    width: 85% !important;\n    padding-left: 0;\n    margin-right: 0;\n    padding-top: 20px !important;\n    padding-left: 0% !important;\n\n  }\n\n  .right-side {\n    width: 80% !important;\n    margin-right: 0;\n    padding-top: 20% !important;\n    padding-left: 7% !important;\n    padding-bottom: 20% !important;\n    z-index: 101;\n  }\n\n  .giant-image {\n    /* padding-top: 40% !important; */\n    right: 0% !important;\n    top: 30% !important;\n    max-width: 100% !important;\n    opacity: 0.8 !important;\n  }\n\n  .cards {\n    margin-top: 20px;\n  }\n\n\n  .menu-link-text {\n    font-size: 3rem !important;\n    /* marign-top: 20% !important; */\n    font-weight: 600 !important;\n  }\n\n  .work-time {\n    padding-top: 20% !important;\n    font-weight: bold !important;\n    z-index: 1002;\n    /* padding-bottom: 20% !important; */\n  }\n\n  .home-top-info {\n    flex-direction: column;\n    align-items: center;\n    padding: 50px 5% 0 5%;\n  }\n\n  .circle-badge {\n    position: static;\n    margin-bottom: 20px;\n  }\n\n  .work-time.lifted {\n    width: auto;\n    margin: 0;\n  }\n}\n\n@media (min-width: 769px) and (max-width: 1024px) {\n  .home-container{\n    background: url('../../assets/menu_background_rotated_min.jpg') no-repeat center center;\n    background-size: cover;\n    padding-top: 20%;\n  }\n  \n  footer {\n    margin-top:0% !important;\n  }\n\n  .right-side {\n    width: 50% !important;\n    margin-right: 0;\n    padding-top: 20% !important;\n    padding-left: 7% !important;\n    padding-bottom: 20% !important;\n    z-index: 101;\n  }\n  \n}\n\n@media (min-width: 3840px) {\n \n  #home p {\n    font-family: Georgia, serif;\n    color: #333;\n    font-size: 4rem !important;\n    font-weight: normal;\n    margin: 0;\n    text-align: justify;\n    line-height: 1.5;\n  }\n  \n  .first-letter {\n    font-family: 'Palace Script MT', cursive;\n    font-size: 12rem !important;\n    line-height: 0.8;\n  }\n\n  .menu-link-text {\n    font-size: 10rem !important;\n  }\n  \n  .menu-link-container {\n    bottom: 0% !important;\n  }\n\n  .giant-image {\n    position: absolute;\n    right: 62% !important;\n    top: 20%;\n    max-width: 40%;\n    height: auto;\n    opacity: 0;\n    transition: opacity 2s ease-in-out;\n    z-index: 1;\n  }\n}\n\n.left-side {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  position: relative;\n  width: 55%;\n  padding-left: 5%;\n  padding-top: 5%;\n}\n\n.giant-image {\n  position: absolute;\n  right: 60%;\n  top: 20%;\n  max-width: 40%;\n  height: auto;\n  opacity: 0;\n  transition: opacity 2s ease-in-out;\n  z-index: 1;\n}\n\n.giant-image.fade-in {\n  opacity: 0.5;\n}\n\n.work-time {\n  padding-top: 5%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity 4s ease-in-out;\n}\n\n#home {\n  padding-top: 0 !important;\n}\n\n.work-time.fade-in {\n  opacity: 1;\n}\n\n.text-container {\n  left: 5%;\n  align-items: justify;\n  z-index: 2;\n}\n\n#home p {\n  font-family: Georgia, serif;\n  color: #333;\n  font-size: 30px;\n  font-weight: normal;\n  margin: 0;\n  text-align: justify;\n  line-height: 1.5;\n}\n\n.first-letter {\n  font-family: 'Palace Script MT', cursive;\n  font-size: 6rem;\n  line-height: 0.8;\n}\n\n.first-letter-two {\n  font-family: 'Palace Script MT', cursive;\n  font-size: 8rem;\n  line-height: 0.8;\n}\n\n.first-letter-three {\n  font-family: 'Palace Script MT', cursive;\n  font-size: 4rem;\n  line-height: 0.8;\n}\n\n.work-text {\n  font-family: 'Palace Script MT', cursive;\n  font-size: 6rem;\n  line-height: 0.8;\n}\n\n.chunk {\n  display: inline-block;\n  transition: transform 0.3s ease-in-out;\n  cursor: pointer;\n}\n\n.animated-text {\n  opacity: 0;\n  transition: opacity 4s ease-in-out;\n}\n\n.animated-text.fade-in {\n  opacity: 1;\n}\n\n.chunk:hover {\n  transform: scale(1.1);\n}\n\n.right-side {\n  width: 30%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-right: 8%;\n  padding-top: 3%;\n  opacity: 0;\n  transition: opacity 4s ease-in-out;\n}\n\n.right-side.fade-in {\n  opacity: 1;\n}\n\n.cards {\n  position: relative;\n  list-style-type: none;\n  padding: 0;\n  width: 100%;\n  margin: 0;\n}\n\n.card {\n  position: relative;\n  background: #ccc;\n  border-radius: 30px;\n  box-shadow: 0 0 40px #000;\n  transform: translateY(0) rotate(0) translateX(0) scale(1);\n  transform-origin: 0 0;\n  transition: transform 0.6s cubic-bezier(.8,.2,.1,0.8) 0.1s, background 0.4s linear;\n  cursor: pointer;\n  user-select: none;\n  width: 100%;\n  z-index: 1;\n}\n\n.card img {\n  width: 100%;\n  height: auto;\n  border-radius: 30px;\n  transition: transform 0.3s ease-in-out;\n}\n\n.card--current {\n  cursor: pointer;\n  user-select: auto;\n  position: relative;\n  z-index: 5;\n  opacity: 1;\n  margin-top: -40%;\n  background: #EEE;\n}\n\n.card--next {\n  z-index: 3;\n}\n\n.card--out {\n  z-index: 4;\n  margin-top: -40%;\n}\n\n.card img:hover {\n  transform: scale(1.1);\n}\n\n.radno-vrijeme-kuhinje {\n  display: flex;\n  margin-top: 10%;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Palace Script MT', cursive;\n  font-size: 2rem;\n}\n\n#home.show {\n  display: flex;\n}\n\n.menu-link-container {\n  position: absolute;\n  bottom: 20%;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 2;\n  opacity: 0;\n  transition: opacity 4s ease-in-out;\n}\n\n.menu-link-container.fade-in {\n  opacity: 1;\n}\n\n.menu-link-text {\n  font-family: 'Palace Script MT', cursive;\n  font-size: 5rem;\n  color: #333;\n  text-decoration: none;\n}\n\n.menu-link-text:hover {\n  color: #555;\n}\n\nfooter {\n  margin-top:20%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
